// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__oNgc8","vertical":"styles_vertical__FKh6I"};